export const convertHtmlIntoHumanText = (text: string): string => {
  const stripped = stripHtmlIntoText(text)
  const humanText = prepareForScreenReader(stripped)
  return humanText
}

const stripHtmlIntoText = (input: string): string => {
  if (!input) return ''

  let text: string = input

  // Wraps editable with 'starts' and 'ends'
  text = text.replace(
    /<[^>]*class=['"][^'"]*\beditable\b[^'"]*['"][^>]*>(.*?)<\/[^>]+>/gi,
    'editable starts $1 editable ends'
  )

  // Replace common block-level tags with newlines
  text = text
    .replace(/<\/p>/gi, '\n\n')
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<\/div>/gi, '\n')

  // Strip all remaining tags
  text = text.replace(/<\/?[^>]+(>|$)/g, '')

  // Decode HTML entities
  const txt = document.createElement('textarea')
  txt.innerHTML = text
  text = txt.value

  // Replace multiple spaces/newlines with clean spacing
  text = text.replace(/\u00A0/g, ' ') // non-breaking spaces → space
  text = text.replace(/\s+\n/g, '\n').replace(/\n\s+/g, '\n')
  text = text.replace(/\n{3,}/g, '\n\n')
  text = text.replace(/ +/g, ' ')

  return text.trim()
}

const prepareForScreenReader = (text: string): string => {
  if (!text) return ''

  return (
    text
      // Paragraph breaks = strong pause
      .replace(/\n{2,}/g, '. ')
      // Single line breaks = pause
      .replace(/\n/g, ', ')
      // Add pause after "editable <something>"
      .replace(/\b(editable\s+[^\s]+)/gi, '$1,')
      // Collapse multiple spaces
      .replace(/ +/g, ' ')
      .trim()
  )
}
